<script>
	import confirmationPages from "../confirmationPages";
	import { projectSettings } from "../../config";
	import model from "../../stores/modelStore";

	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";

	let disabled = true;

	document.title = `${projectSettings.classActionName} - Review`;

	// Check if there is a function to call in routes.js which will determine if a page is to be shown,
	// otherwise just show it.
	const displayComponent = (page) => {
		if (page && page.showComponent && typeof page.showComponent === "function") {
			return page.showComponent($model);
		}
		return true;
	};
</script>

<section>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
		</FormColumn>
	</FormRow>

	<div class="confirmation">
		{#each confirmationPages as page}
			{#if displayComponent(page)}
				<ReviewSectionHeader heading={page.confirmationHeading}></ReviewSectionHeader>

				<svelte:component this={page.component} {...page} {disabled} />
			{/if}
		{/each}
	</div>
</section>
